import { action, makeObservable, observable } from 'mobx';
import { SelfTestT } from 'src/api/types/SelfTestT';
import { AnswersState } from 'src/selfTest/SelfTestState/AnswersState';
import { PagesState } from 'src/selfTest/SelfTestState/PagesState';
import { stub } from 'src/utils/stub';

type PropsT = {
  selfTest?: SelfTestT;
};

export class SelfTestState {
  @observable answersState: AnswersState = stub();
  @observable pagesState: PagesState = stub();
  @observable selfTest?: SelfTestT = stub();
  @observable portalElm?: any = stub();

  @action setSelfTest = (selfTest: SelfTestT | undefined) => {
    this.selfTest = selfTest;
    this.answersState = new AnswersState(this.selfTest?.scoreRangeSet ?? []);
    this.pagesState = new PagesState(
      this.selfTest?.questionSet ?? [],
      this.answersState
    );
  };

  @action setPortalElm = (elm: any) => {
    this.portalElm = elm;
  };

  constructor(props: PropsT) {
    this.setSelfTest(props.selfTest);

    makeObservable(this);
  }
}
